export const UP = 'up';
export const DOWN = 'down';
export const LEFT = 'left';
export const RIGHT = 'right';
export const BEFORE = 'before';
export const AFTER = 'after';
